import React, { useMemo, useRef, useState } from "react";
import { FiSave } from "react-icons/fi";
import styles from "./formcliente.module.css";
import ui from "../../styles/ui.module.css";

const Clienteform = ({ adicionarCliente, formData, setFormData, editing = false, onCancel }) => {
  const nomeInputRef = useRef(null);
  const maskCpfCnpj = (value) => {
    const digits = (value || '').replace(/\D/g, '');
    if (digits.length <= 11) {
      return digits
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    }
    return digits
      .replace(/(\d{2})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1.$2')
      .replace(/(\d{3})(\d)/, '$1/$2')
      .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
  };
  const maskTelefone = (value) => {
    const d = (value || '').replace(/\D/g, '');
    if (d.length <= 10) {
      // (99) 9999-9999
      return d
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .slice(0, 14);
    }
    // (99) 99999-9999
    return d
      .replace(/(\d{2})(\d)/, '($1) $2')
      .replace(/(\d{5})(\d)/, '$1-$2')
      .slice(0, 15);
  };
  const maskCep = (value) => {
    const d = (value || '').replace(/\D/g, '');
    return d.replace(/(\d{5})(\d)/, '$1-$2').slice(0, 9);
  };
  const cepDigits = (v) => (v || '').replace(/\D/g, '');
  const [cepLoading, setCepLoading] = useState(false);
  const [cepMsg, setCepMsg] = useState('');
  const [lastCepFetched, setLastCepFetched] = useState('');

  const fetchCep = async (digits) => {
    try {
      setCepLoading(true);
      setCepMsg('Buscando CEP...');
      const resp = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
      const data = await resp.json();
      if (data.erro) {
        setCepMsg('CEP não encontrado');
      } else {
        setFormData((prev) => ({
          ...prev,
          endereco: data.logradouro || prev.endereco || '',
          bairro: data.bairro || prev.bairro || '',
          cidade: data.localidade || prev.cidade || '',
          uf: (data.uf || prev.uf || '').toUpperCase(),
        }));
        setCepMsg('Endereço preenchido pelo CEP');
      }
    } catch (e) {
      setCepMsg('Erro ao consultar CEP');
    } finally {
      setCepLoading(false);
      setLastCepFetched(digits);
      setTimeout(() => setCepMsg(''), 3000);
    }
  };
  const cpfValid = useMemo(() => {
    const digits = (formData.cpf || '').replace(/\D/g, '');
    return digits.length === 0 || digits.length === 11 || digits.length === 14;
  }, [formData.cpf]);
  const telValid = useMemo(() => {
    const d = (formData.telefone || '').replace(/\D/g, '');
    return d.length === 10 || d.length === 11 || d.length === 0; // opcional
  }, [formData.telefone]);
  const cepValid = useMemo(() => {
    const d = (formData.cep || '').replace(/\D/g, '');
    return d.length === 8 || d.length === 0; // opcional
  }, [formData.cep]);
  const ufValid = useMemo(() => {
    const u = (formData.uf || '').trim().toUpperCase();
    return u.length === 2 || u.length === 0; // opcional
  }, [formData.uf]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'cpf') {
      setFormData({ ...formData, cpf: maskCpfCnpj(value) });
      return;
    }
    if (name === 'telefone') {
      setFormData({ ...formData, telefone: maskTelefone(value) });
      return;
    }
    if (name === 'cep') {
      const masked = maskCep(value);
      setFormData({ ...formData, cep: masked });
      const d = cepDigits(masked);
      if (d.length === 8 && d !== lastCepFetched && !cepLoading) {
        fetchCep(d);
      }
      return;
    }
    if (name === 'uf') {
      setFormData({ ...formData, uf: (value || '').toUpperCase().slice(0,2).replace(/[^A-Z]/g,'') });
      return;
    }
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const d = cepDigits(formData.cep);
    if (formData.cep && d.length > 0 && d.length !== 8) {
      setCepMsg('CEP inválido');
      return;
    }
    adicionarCliente(formData);
    if (nomeInputRef.current) nomeInputRef.current.focus();
  };

  return (
    <form className={styles["cliente-formulario"]} onSubmit={handleSubmit}>
      <div className={styles["cliente-form"]}>
          <div>  
            <input
              type="text"
              name="nome"
              value={formData.nome}
              onChange={handleChange}
              placeholder="Nome Completo"
              autoComplete="name"
              className={`${ui.inpdesktop}`}
              ref={nomeInputRef}
              required
            />
          </div>  
          <div>  
            <input
              type="text"
              name="cpf"
              value={formData.cpf}
              onChange={handleChange}
              placeholder="CPF/CNPJ (somente números)"
              inputMode="numeric"
              autoComplete="off"
              className={`${ui.inpdesktop} ${formData.cpf && !cpfValid ? 'invalid' : ''}`}
            />
          </div>
        {/* Campos adicionais para NF (opcionais por enquanto) */}
        
        <div>
          <input type="text" name="telefone" value={formData.telefone || ''} onChange={handleChange} placeholder="Telefone (opcional)" inputMode="tel" autoComplete="tel" className={`{telValid ? '' : 'invalid'} ${ui.inpdesktop}`} />
        </div>
        <div>
          <input type="email" name="email" value={formData.email || ''} onChange={handleChange} placeholder="E-mail (opcional)" autoComplete="email" className={`${ui.inpdesktop}`}/>
        </div>
        
        <div className={styles["cliente-cep-group"]}>
          <input
            type="text"
            name="cep"
            value={formData.cep || ''}
            onChange={handleChange}
            onBlur={async () => {
              const digits = cepDigits(formData.cep);
              if (digits.length !== 8) { setCepMsg(''); return; }
              if (digits !== lastCepFetched && !cepLoading) {
                await fetchCep(digits);
              }
            }}
            placeholder="CEP"
            inputMode="numeric"
            className={`${cepValid ? '' : 'invalid'} ${ui.inpdesktop}`}
          />
          <button type="button" className={styles["cliente-cep-btn"]} title="Buscar CEP"
            disabled={cepLoading || cepDigits(formData.cep).length !== 8}
            onClick={() => {
              const d = cepDigits(formData.cep);
              if (d.length === 8 && d !== lastCepFetched && !cepLoading) fetchCep(d);
            }}
          >Buscar</button>
          
          {cepMsg && (
            <small className={`${styles["mensagem-cep"]} ${cepLoading ? styles["mensagem-cep--loading"] : styles["mensagem-cep--ok"]}`}>
              {cepMsg}
            </small>
          )}
        </div>
        <div>
          <input className={`${ui.inpdesktop}`} type="text" name="endereco" value={formData.endereco || ''} onChange={handleChange} placeholder="Endereço (rua/av.)" />
        </div>
        <div>
          <input className={`${ui.inpdesktop}`} type="text" name="numero" value={formData.numero || ''} onChange={handleChange} placeholder="Número" />
        </div>
        <div>
          <input className={`${ui.inpdesktop}`} type="text" name="complemento" value={formData.complemento || ''} onChange={handleChange} placeholder="Complemento (opcional)" />
        </div>
        <div>
          <input className={`${ui.inpdesktop}`} type="text" name="bairro" value={formData.bairro || ''} onChange={handleChange} placeholder="Bairro" />
        </div>
        <div>
          <input className={`${ui.inpdesktop}`} type="text" name="cidade" value={formData.cidade || ''} onChange={handleChange} placeholder="Cidade" />
        </div>
        <div>
          <input type="text" name="uf" value={formData.uf || ''} onChange={handleChange} placeholder="UF" autoComplete="address-level1" className={`${ufValid ? '' : 'invalid'} ${ui.inpdesktop}`} />
        </div>
        <div>
          <input className={`${ui.inpdesktop}`} type="text" name="codigoMunicipio" value={formData.codigoMunicipio || ''} onChange={handleChange} placeholder="Cód. Município IBGE (opcional)" inputMode="numeric" />
        </div>
        <div>
          <input className={`${ui.inpdesktop}`} type="text" name="ie" value={formData.ie || ''} onChange={handleChange} placeholder="Inscrição Estadual (se houver)" />
        </div>

        <div className={`${ui.divbutsalvar}`}>
          {/*<button type="button" className={styles["cliente-cancelar"]} onClick={onCancel}>{editing ? 'Cancelar' : 'Fechar'}</button>*/}
          <button className={`${ui.butdesktop}`} type="submit">{editing ? 'Atualizar' : 'Salvar'}</button>
          {/*<button className={styles["cliente-submit-svg"]} type="submit"><FiSave /></button>*/}
        </div>
      </div>
    </form>
  );
};

export default Clienteform;
